<template>
  <div class="content-top-padding" v-cloak>
    <div class="container my-5">
      <div class="row d-inline-flex mb-5">
        <div class="col align-self-center pr-0">
          <button class="back-btn">
            <img
              alt=""
              class="back-arrow"
              src="@/assets/01/icon_sitemapback.svg"
              @click="goBack()"
            />
          </button>
        </div>
        <div class="col-auto">
          <div class="main-theme text-uppercase font-weight-bold">
            <h2>{{ $t("footer.sitemap") }}</h2>
          </div>
        </div>
      </div>
      <div class="row main-theme mb-1">
        <div class="col-12">
          <h4>{{ $t("title.ChairmanMsg&ED") }}</h4>
        </div>
      </div>
      <div class="row text-theme mb-4">
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">
          <router-link :to="{ name: 'Chairman' }">
            {{ $t("title.ChairmanMsg") }}
          </router-link>
        </div>
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">
          <router-link :to="{ name: 'ED' }">
            {{ $t("title.ED") }}
          </router-link>
        </div>
      </div>
      <div class="row main-theme mb-4">
        <div class="col-12">
          <router-link :to="{ name: 'BoardMembers' }">
            <h4>{{ $t("title.bms") }}</h4>
          </router-link>
        </div>
      </div>
      <div class="row main-theme mb-4">
        <div class="col-12">
          <router-link :to="{ name: 'SupportToEconomy' }">
            <h4>{{ $t("title.supportToEcon") }}</h4>
          </router-link>
        </div>
      </div>
      <div class="row main-theme mb-1">
        <div class="col-12">
          <router-link :to="{ name: 'Initiatives' }">
            <h4>{{ $t("title.init") }}</h4>
          </router-link>
        </div>
      </div>
      <div class="row text-theme mb-4">
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">
          <router-link :to="{ name: 'HolidayAtHome' }">
            {{ $t("title.holiday") }}
          </router-link>
        </div>
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">
          <router-link :to="{ name: 'GlobalVisibility-MissYouToo' }">
            {{ $t("title.gv") }}
          </router-link>
        </div>
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">
          <router-link :to="{ name: 'GearingUpTheTrade-Uncease' }">
            {{ $t("title.gearing") }}
          </router-link>
        </div>
      </div>
      <div class="row main-theme mb-1">
        <div class="col-12">
          <router-link :to="{ name: 'AboutUs' }">
            <h4>{{ $t("title.aboutUs") }}</h4>
          </router-link>
        </div>
      </div>
      <div class="row text-theme">
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">{{ $t("title.award") }}</div>
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">
          <router-link :to="{ name: 'Map' }">
            {{ $t("title.worldwide") }}
          </router-link>
        </div>
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">{{ $t("title.corp") }}</div>
        <div class="col-12 col-lg-4 mb-2 mb-lg-0">{{ $t("title.report") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sitemap",
  methods: {
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 0;
}
h2,
h4 {
  font-weight: bold !important;
}
.main-theme {
  text-shadow: 1px 1px lightgrey;
}
.text-theme {
  a {
    color: #777777;
  }
}
.back-arrow {
  width: 2.2rem;
}
.back-btn {
  background: none;
  border: 0;
  padding: 0;
}
@media (max-width: 450px) {
  h4 {
    font-size: 1.35rem;
  }
}
</style>
